import bookingsPage from "./bookings.component";
import bookingsUrls from "./bookings.urls";
import BookingsTransforms from "./bookings.transforms";
import PendingBookingsTransforms from "./pendingBookings.transforms";

const bookingsModule = angular
  .module("app.pages.bookings", [])
  .component("bookingsPage", bookingsPage)
  .service("BookingsTransforms", BookingsTransforms)
  .service("PendingBookingsTransforms", PendingBookingsTransforms)
  .config(bookingsUrls);

export default bookingsModule;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookings.module.js